import React from 'react'
import { Navigate } from 'react-router-dom'

import { ProtectedPage } from '../pages/base/protected-page'
import { ConsignmentsBooking } from '../pages/consignments'
import { MerchantWarehouses } from '../pages/merchant-warehouses'
import { Configurations, TerminalRelations } from '../pages/pallets'
import { Start } from '../pages/start'
import { TerminalGroups } from '../pages/terminals/groups'

export const routeList = [
  {
    path: '/',
    element: <ProtectedPage component={Start} />,
  },
  {
    path: '/status',
    element: <div>OK</div>,
  },
  {
    path: '/consignments/booking',
    element: <ProtectedPage component={ConsignmentsBooking} />,
  },
  {
    path: '/pallets/terminal-relations',
    element: <ProtectedPage component={TerminalRelations} fixedPageHeight />,
  },
  {
    path: '/pallets/configurations',
    element: <ProtectedPage component={Configurations} fixedPageHeight />,
  },
  {
    path: '/locations/terminal-groups',
    element: <ProtectedPage component={TerminalGroups} fixedPageHeight />,
  },
  {
    path: '/locations/merchant-warehouses',
    element: <ProtectedPage component={MerchantWarehouses} fixedPageHeight />,
  },
  {
    path: '*',
    element: <Navigate to="/" />,
  },
]
